function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "education_x5F_student",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 32.095",
    style: {
      enableBackground: "new 0 0 28 32.095"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "28,32.095 26,32.095 26,27.771 16,23.771 16,19.681 19,16.681 19,13.095 21,13.095  21,17.509 18,20.509 18,22.418 28,26.418  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "2,32.095 0,32.095 0,26.418 10,22.418 10,20.509 7,17.509 7,13.095 9,13.095 9,16.681  12,19.681 12,23.771 2,27.771  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M14,10.189L2.538,5.095L14,0l11.462,5.095L14,10.189z M7.462,5.095L14,8l6.538-2.905L14,2.189 L7.462,5.095z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 7.095,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6.095,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11.095,
    style: {
      fill: "#FD5C3F"
    },
    width: 14,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 5.095,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 15.095,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationStudent);
export default __webpack_public_path__ + "static/media/education_student.077bc15fdbd00a488b449bed9549782c.svg";
export { ForwardRef as ReactComponent };